var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M33 38v2a1 1 0 0 0 1 1h1l1.8 16.22A2 2 0 0 0 38.79 59H5a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h38a4 4 0 0 1 4 4v26H36a3 3 0 0 0-3 3z",
    opacity: 1,
    "data-original": "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cfd8dc",
    d: "M36.8 57.22 35 41h-1a1 1 0 0 1-1-1v-2a3 3 0 0 1 3-3h-3a3 3 0 0 0-3 3v2a1 1 0 0 0 1 1h1l1.8 16.22A2 2 0 0 0 35.79 59h3a2 2 0 0 1-1.99-1.78zM43 5h-3a4 4 0 0 1 4 4v26h3V9a4 4 0 0 0-4-4z",
    opacity: 1,
    "data-original": "#cfd8dc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 10,
    r: 2,
    fill: "#9e9e9e",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 10,
    r: 2,
    fill: "#9e9e9e",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 10,
    r: 2,
    fill: "#9e9e9e",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 10,
    r: 2,
    fill: "#9e9e9e",
    opacity: 1,
    "data-original": "#9e9e9e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02a9f4",
    d: "M59 38v2a1 1 0 0 1-1 1H34a1 1 0 0 1-1-1v-2a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3z",
    opacity: 1,
    "data-original": "#02a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "M56 35h-3a3 3 0 0 1 3 3v2a1 1 0 0 1-1 1h3a1 1 0 0 0 1-1v-2a3 3 0 0 0-3-3z",
    opacity: 1,
    "data-original": "#0377bc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02a9f4",
    d: "m57 41-1.8 16.22A2 2 0 0 1 53.21 59H38.79a2 2 0 0 1-1.99-1.78L35 41z",
    opacity: 1,
    "data-original": "#02a9f4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0377bc",
    d: "m54 41-1.8 16.22A2 2 0 0 1 50.21 59h3a2 2 0 0 0 1.99-1.78L57 41z",
    opacity: 1,
    "data-original": "#0377bc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 22a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H8a1 1 0 0 0-1 1zM17 22a1 1 0 0 0 1 1h22a1 1 0 0 0 0-2H18a1 1 0 0 0-1 1zM40 27H8a1 1 0 0 0 0 2h32a1 1 0 0 0 0-2zM8 33a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2zM28 39H8a1 1 0 0 0 0 2h20a1 1 0 0 0 0-2zM8 16a1 1 0 0 0-1-1H6a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1zM11 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM16 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM21 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM26 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM31 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM36 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2zM41 17h1a1 1 0 0 0 0-2h-1a1 1 0 0 0 0 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M56 34h-4v-1a3 3 0 0 0-3-3h-1V9a5.006 5.006 0 0 0-5-5h-3V1a1 1 0 0 0-2 0v3h-8V1a1 1 0 0 0-2 0v3h-8V1a1 1 0 0 0-2 0v3h-8V1a1 1 0 1 0-2 0v3H5a5.006 5.006 0 0 0-5 5v46a5.006 5.006 0 0 0 5 5h48.21a3 3 0 0 0 2.981-2.669L57.9 42h.1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4zm-6-1v1h-8v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zM2 55V17a1 1 0 0 0 0-2V9a3 3 0 0 1 3-3h3v1.184a3 3 0 1 0 2 0V6h8v1.184a3 3 0 1 0 2 0V6h8v1.184a3 3 0 1 0 2 0V6h8v1.184a3 3 0 1 0 2 0V6h3a3 3 0 0 1 3 3v6a1 1 0 0 0 0 2v13h-3a3 3 0 0 0-3 3v1h-4a4 4 0 0 0-4 4v2a2 2 0 0 0 2 2h.1l1.7 15.332c.031.228.088.453.17.668H5a3 3 0 0 1-3-3zM9 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm10 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm10 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm10 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm15.2 48.11a1 1 0 0 1-.994.89H38.79a1 1 0 0 1-.994-.89L36.117 42h19.766zM58 40H34v-2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 55a1 1 0 0 0 1-1v-8a1 1 0 0 0-2 0v8a1 1 0 0 0 1 1zM51 55a1 1 0 0 0 1-1v-8a1 1 0 0 0-2 0v8a1 1 0 0 0 1 1zM41 55a1 1 0 0 0 1-1v-8a1 1 0 0 0-2 0v8a1 1 0 0 0 1 1z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3f83f515035939810844accda6218843.svg";
export { ForwardRef as ReactComponent };